module.exports = __webpack_public_path__ + "img/工作看板.8554045c.jpg";